// extracted by mini-css-extract-plugin
export default {"root":"IAv6C","icon":"_3tkse"};